// DEPRECATED: VettScoreCard has been replaced by VettTierCard
// This file re-exports VettTierCard for backward compatibility
import VettTierCard from './VettTierCard';
export default VettTierCard;
